import type { ReactNode } from 'react'

interface GlassCardProps {
  children: ReactNode
  className?: string
  hover?: boolean
}

export default function GlassCard({
  children,
  className = '',
  hover = true,
}: GlassCardProps) {
  return (
    <div
      className={`
        relative overflow-hidden rounded-2xl border border-white/10
        bg-gradient-to-br from-white/[0.07] to-white/[0.02]
        backdrop-blur-xl shadow-xl
        ${hover ? 'transition-all duration-500 hover:border-white/20 hover:shadow-2xl hover:shadow-premium-500/10 hover:-translate-y-1' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  )
}
